import * as config from '../common/config';

/**
 * Set value with specified key to local or session
 * @param {string} key storage key
 * @param {string | object} value storage value
 * @param {boolean} [session=false] whether use session storage
 */
function setItem(key: string, value: string | object, session: boolean = false) {
  value = typeof value === 'object' ? JSON.stringify(value) : value;
  session ? window.sessionStorage.setItem(key, value) : window.localStorage.setItem(key, value);
}

/**
 * Get value with specified key from local or session
 * @param {string} key storage key
 * @param {('localStorage' | 'sessionStorage')} [type] whether use session storage
 * @return {(string | null)}  storage value
 */
function getItem(key: string, type?: 'localStorage' | 'sessionStorage'): string | null {
  return type ? window[type].getItem(key) : window.localStorage.getItem(key) || window.sessionStorage.getItem(key);
}

/**
 * Remove storage with specified key, both local and session
 * @param {string} key storage key
 */
function removeItem(key: string) {
  window.localStorage.removeItem(key);
  window.sessionStorage.removeItem(key);
}

/**
 *
 * Save user info to local storage
 * @param {object} userInfo
 */
function setUserInfo(userInfo: object) {
  setItem(config.storageKey.userInfo, userInfo, true);
}

/**
 *
 * Remove user info from local storage
 *
 */
function removeInfo() {
  removeItem(config.storageKey.userInfo);
}
/**
 * Get user info value from storage
 */
function getUserInfo(): Object {
  return JSON.parse(getItem(config.storageKey.userInfo, 'sessionStorage'));
}

export default {
  setItem,
  getItem,
  removeItem,
  setUserInfo,
  removeInfo,
  getUserInfo,
};
